// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../factories/translate-dialog";
import "./../../bindings/bao-upload";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-pager";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaseViewModel from "./../../factories/base-view-model2";
import TabController from "./../../factories/tab-controller";
import BaoDialog from "./../../factories/bao-dialog";
import SaveChecklistDialog from "./dialogs/save-checklist-dialog";
import baoDialog from "./../../factories/bao-dialog";
import TranslateDialogViewModel from "./../../factories/translate-dialog";
import * as moment from "moment";
import baoRouter from "../../services/bao-router";

class Checklist extends BaseViewModel {
    childwindow;
    ko = ko;
    Bao = Bao;
    Dialog: baoDialog;
    ChecklistFieldTab: TabPage;
    ChecklistResourceTab: TabPage;
    ChecklistId: KnockoutObservable<string> = ko.observable();
    TemplateUploadEnabled: KnockoutObservable<boolean> = ko.observable(true);
    ChecklistCategoryId: KnockoutObservable<string> = ko.observable();
    FieldIdShownInTabName: KnockoutObservable<string> = ko.observable();
    PdfPageSizeId: KnockoutObservable<string> = ko.observable();
    PdfStandardSubsetId: KnockoutObservable<string> = ko.observable();
    EventScriptId: KnockoutObservable<string> = ko.observable();
    Revision: KnockoutObservable<string> = ko.observable();
    Revisiondescription: KnockoutObservable<string> = ko.observable();

    PdfFileName: KnockoutObservable<string> = ko.observable();
    IsPublished: KnockoutObservable<boolean> = ko.observable(false);

    ShowEditInDesignerButton: KnockoutObservable<boolean> = ko.observable(true);
    ShowDownLoadButton: KnockoutObservable<boolean> = ko.observable(true);
    ShowEmptyChecklist: any = ko.observable(false);
    SessionDetail: any = ko.observableArray();
    SelectedFileNames: any = ko.observableArray();
    CheckwareDesignerUrl: KnockoutObservable<string> = ko.observable();

    ListName1: KnockoutObservable<string> = ko.observable();
    ListName2: KnockoutObservable<string> = ko.observable();
    ListName3: KnockoutObservable<string> = ko.observable();
    ListName4: KnockoutObservable<string> = ko.observable();
    ListName5: KnockoutObservable<string> = ko.observable();
    Description1: KnockoutObservable<string> = ko.observable();
    Description2: KnockoutObservable<string> = ko.observable();
    Description3: KnockoutObservable<string> = ko.observable();
    Description4: KnockoutObservable<string> = ko.observable();
    Description5: KnockoutObservable<string> = ko.observable();
    ListName = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.ListName1();
                case 2:
                    return this.ListName2();
                case 3:
                    return this.ListName3();
                case 4:
                    return this.ListName4();
                case 5:
                    return this.ListName5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.ListName1(value);
                    break;
                case 2:
                    this.ListName2(value);
                    break;
                case 3:
                    this.ListName3(value);
                    break;
                case 4:
                    this.ListName4(value);
                    break;
                case 5:
                    this.ListName5(value);
                    break;
            }
        }
    });
    Description = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Description1();
                case 2:
                    return this.Description2();
                case 3:
                    return this.Description3();
                case 4:
                    return this.Description4();
                case 5:
                    return this.Description5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Description1(value);
                    break;
                case 2:
                    this.Description2(value);
                    break;
                case 3:
                    this.Description3(value);
                    break;
                case 4:
                    this.Description4(value);
                    break;
                case 5:
                    this.Description5(value);
                    break;
            }
        }
    });

    TemplateName = ko.pureComputed(function () {
        return this.ListName() || this.PdfFileName();
    }, this);
    ChecklistField: Bindings.baoSearcher = {
        ObjectId: this.FieldIdShownInTabName,
        ObjectValue: 'MatchCode',
        AutoComplete: true,
        AutoSearch: true,
        SearchType: 'Checkware-Field',
        CustomFilter: { checklistfields: this.ChecklistId, filterFieldTypes: ["TEXT", "NUMBER", "DATETIME"] }
    };
    SearcherCategory: Bindings.baoSearcher = {
        ObjectId: this.ChecklistCategoryId,
        ObjectValue: "ChecklistCategoryName",
        SearchType: "ChecklistCategory",
        AutoComplete: true,
        AutoSearch: true
    };
    SearcherPageSize: Bindings.baoSearcher = {
        ObjectId: this.PdfPageSizeId,
        ObjectValue: "PageSize",
        SearchType: "Checkware-PageSize",
        AutoComplete: true,
        AutoSearch: true
    };
    SearcherPdfStandardSubset: Bindings.baoSearcher = {
        ObjectId: this.PdfStandardSubsetId,
        ObjectValue: "Name",
        SearchType: "Checkware-PdfStandardSubset",
        AutoComplete: true,
        AutoSearch: true
    };
    constructor(tabPage: TabPage) {
        super(tabPage);

        //To manage the visibility of "Download" and "Edit In Designer buttons"
        this.SelectedFileNames.subscribe(fileNames => {

            this.ShowEmptyChecklist(true);
            this.ShowDownLoadButton(false);
            this.ShowEditInDesignerButton((fileNames == null || fileNames.length <= 0));
        })

        window.addEventListener("message", this.windowMessage);
    }

    windowMessage = (event) => {
        //To identify if parent is calling the child with the associated checklist
        if (this.ChecklistId() === event.data.currentChecklistId) {
            if (event.data !== undefined && event.data.callChild === true) {
                let messageObject = { title: this.TemplateName(), session: this.SessionDetail(), originUrl: window.location.origin + window.location.pathname }
                if (this.childwindow) {
                    this.childwindow.postMessage(messageObject, this.CheckwareDesignerUrl())
                }
            }
            //This condition will execute when user will publish the template from designer
            else if (event.data.message.isPublished === true) {
                this.ShowEditInDesignerButton(false);
                this.IsPublished(true);
                this.PdfFileName(event.data.message.templateName)
                this.SelectedFileNames = ko.observableArray([event.data.message.templateName]);
                this.TabPage.DirtyFlag(true);

                window.focus();
            }
        }

    }

    GoToEventScript = () => {
        baoRouter.setHash("Checkware/EventScript/" + this.EventScriptId())
    };
    SearcherEventScript: Bindings.baoSearcher = {
        ObjectId: this.EventScriptId,
        ObjectValue: "DetailedName",
        SearchType: "Checkware-EventScript",
        AutoComplete: true,
        AutoSearch: true,
        GotoVisible: Bao.Session.HasPermission('EventScriptSearch', '7A392A95-576D-444F-8375-5FEA08B153CA'),
        Goto: this.GoToEventScript
    };
    TranslateListName() {
        let translateDialog = new TranslateDialogViewModel(this.ListName1, this.ListName2, this.ListName3, this.ListName4, this.ListName5);
        translateDialog.Open().then(() => {
        });
    }
    ;
    TranslateDescription() {
        let translateDialog = new TranslateDialogViewModel(this.Description1, this.Description2, this.Description3, this.Description4, this.Description5);
        translateDialog.Open().then(() => {
        });
    }
    ;
    OpenRevisionDescription() {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, this.Revisiondescription().replace("\n", "<br>"));
        dialog.Buttons([
            {
                Title: Bao.Session.GetMessage("msgOk"),
                Click: () => {
                    dialog.Close();
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(true),
                Focus: () => { }
            }
        ]);
        dialog.Open();
    }
    ;
    Download() {
        window.open(Bao.Content("Checklist/Download/" + this.ChecklistId()), '_blank');
    }
    ;
    UploadTemplate = () => {
        return $.Deferred().promise();
    };
    MenuClick = (action) => {
        if (this.TabPage.IsActiveTab()) {
            switch (action.ActionKey()) {
                case "ChecklistAudit":
                    this.OpenChecklistHistoryDialog();
                    break;
            }
        }
    };
    Save(): JQueryPromise<any> {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        Bao.post("Checklist/SaveChecklistDialog", JSON.stringify({})).always(() => {
            this.TabPage.IsLoading(false);
        }).then((result) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.Template(result);
            dialog.Width("1600px");
            dialog.ViewModel(this);
            dialog.Buttons([
                {
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: () => {
                        let uploadTemplateResult;
                        this.SaveChecklistDialog.ItemCompleteCheck()
                            .then((check_is_successful) => {
                                if (check_is_successful !== true) {
                                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                                    return $.Deferred().reject();
                                }
                                dialog.Close();
                                this.TabPage.IsLoading(true);
                                this.Revision(this.SaveChecklistDialog.NewRevision());
                                this.Revisiondescription(this.SaveChecklistDialog.NewRevisionDescription());
                                return;
                            }).then(() => {
                                return this.UploadTemplate();
                            }).then(() => {
                                let saveObject = Object.assign({}, this);
                                delete saveObject.childwindow;

                                return Bao.post(this.SaveUrl(), JSON.stringify({
                                    model: ko.map.toJS(saveObject)
                                }));
                            }).done((serverResult: {
                                SaveTime: string;
                                UploadTemplateResult: string;
                            }) => {
                                uploadTemplateResult = serverResult.UploadTemplateResult;
                            }).then((serverResult: {
                                SaveTime: string;
                                UploadTemplateResult: string;
                            }) => {
                                return this.TabController.SaveTabs(serverResult.SaveTime);
                            }).then(() => {
                                return this.PerformRefresh();
                            }).done(() => {
                                if (uploadTemplateResult) {
                                    new BaoDialog(Bao.Session.ApplicationName, uploadTemplateResult, "info");
                                }
                                def.resolve();
                            }).always(() => {
                                this.TabPage.IsLoading(false);
                            });
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(true),
                    Focus: () => { }
                },
                {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: () => {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(false),
                    Focus: () => { }
                }
            ]);
            dialog.Open();
            dialog.SetPosition();
        });
        return def.promise();
    }
    SaveChecklistDialog: SaveChecklistDialog;
    CompleteCheck() {
        let isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.ListName())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    ;
    loaded() {
        super.loaded();
        this.TabPage.IsLoading(false);
    }
    ;
    InitUrl() {
        return "Checklist/Init";
    }

    PerformRefresh(model?: any): JQueryPromise<void> {
        return super.PerformRefresh(model).then(() => {
            return this.ResetButtons();
        })
    }

    OpenChecklistHistoryDialog() {
        this.TabPage.IsLoading(true);
        Bao.post("Checklist/ChecklistHistoryDialog", JSON.stringify({}), ((result) => {
            this.TabPage.IsLoading(false);
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.Template(result);
            dialog.Width("1600px");
            dialog.ViewModel(this.ChecklistId());
            dialog.Open();
            dialog.SetPosition();
            dialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    dialog.Close();
                }
            });
        }));
    }
    ;
    public initTabs() {
        return super.InitTabController().then(() => {
            this.ChecklistFieldTab = new TabPage();
            this.ChecklistFieldTab.IsClosable(false);
            this.ChecklistFieldTab.IsActiveTab(true);
            this.ChecklistFieldTab.Url("ChecklistFieldTab");
            this.TabController.AddTab(this.ChecklistFieldTab);
            this.ChecklistResourceTab = new TabPage();
            this.ChecklistResourceTab.IsClosable(false);
            this.ChecklistResourceTab.Url("ResourceTab");
            this.TabController.AddTab(this.ChecklistResourceTab);
        });
    }
    ;
    public init(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        let def = $.Deferred<void>();
        $.when(super.init(), this.initTabs(), this.GetCheckwareDesginerUri()).then(() => {
            def.resolve();
        });
        this.TabPage.Menu.registerEvent((this.MenuClick));
        return def.promise();
    }


    GetCheckwareDesginerUri() {
        let def = $.Deferred<void>();
        Bao.post("checklist/GetCheckwareDesginerUri", JSON.stringify({})).then((result) => {
            this.CheckwareDesignerUrl(result.CheckwareDesignerUrl);
            def.resolve();
        })
        return def.promise();
    }

    EditTemplateInDesigner() {

        this.TabPage.IsLoading(true);

        Bao.post("Bao/GetSessionInformation", JSON.stringify({})).always(() => {
            this.TabPage.IsLoading(false);
        }).then((result) => {
            this.childwindow = window.open(this.CheckwareDesignerUrl() + "?checklistId=" + this.ChecklistId() + "&newChecklist=" + this.ShowEmptyChecklist() + "&version=" + moment().format("YYYYMMDDhhmmss"), "_blank")
            this.SessionDetail(result);
        })
    }
    /**
     * Will display the hint message for the "MatchcodeValue Shown In Tab" field
     * */
    ShowMatchcodeShownFieldHint = function () {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgMatchcodeValueShownInTabNameHint"), "info");
        dialog.Width("600px");
    }

    protected ResetButtons() {
        this.ShowDownLoadButton(!Bao.Utils.String.IsNullOrEmpty(this.PdfFileName()));
        this.ShowEditInDesignerButton(true);
        this.ShowEmptyChecklist(false);
        this.IsPublished(false);
    }
}
export default Checklist;